module.exports = __webpack_public_path__ + "ed657de692fe92cc928749cffbee2240.svg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/Auth/assets/1-online-stores.svg
// module id = ./app/containers/Auth/assets/1-online-stores.svg
// module chunks = 35